import GroupSelectPanel from './src/group-select-panel';

export default GroupSelectPanel;
